import 'css-chunksrc/client/pages/zonePage/reportsPage/report/styles.scss';export default {
  "report": "_report_1erhi_1",
  "nameBox": "_nameBox_1erhi_19",
  "folderIcon": "_folderIcon_1erhi_27",
  "projectName": "_projectName_1erhi_35",
  "separator": "_separator_1erhi_44",
  "reportName": "_reportName_1erhi_49",
  "row": "_row_1erhi_55",
  "label": "_label_1erhi_62",
  "author": "_author_1erhi_68",
  "authorAvatar": "_authorAvatar_1erhi_76",
  "authorName": "_authorName_1erhi_84",
  "text": "_text_1erhi_89",
  "indicators": "_indicators_1erhi_94"
};